(function() {

    var BLOCK_FREE = '.block-free';
    var BLOCK_VIDEOS = '.block-videos';
    var BLOCK_PARTICIPATIONS = '.block-participations';
    var DELAY_VARIATION = 4000;

    function setupVideoItems(block) {
        block.querySelectorAll('.item-video').forEach(function(video) {
            video.addEventListener('click', function(ev) {
                ev.preventDefault();
                var videoID = ev.currentTarget.getAttribute('data-id');
                MpEventBus.$emit(EVENT_VIDEO_SHOW, videoID);
            });
        });
    }

    function initSwiperBlocks(blockClass) {
        document.querySelectorAll(blockClass).forEach(function(block) {
            var scrollableModule;
            var swiperContainer;
            var nSlides = 0;

            swiperContainer = block.querySelector('.scrollable');
            swiperContainer.classList.add('swiper-container');
            block.querySelector('.items').classList.add('swiper-wrapper');
            block.querySelectorAll('li').forEach(function(slide) {
                slide.classList.add('swiper-slide');
                nSlides++;
            });

            if (blockClass === BLOCK_VIDEOS) {
               setupVideoItems(block);
            }

            if (nSlides <= 1) {
                block.querySelector('.next').classList.add('d-none');
                block.querySelector('.prev').classList.add('d-none');
                return;
            }

            scrollableModule = new Swiper(swiperContainer, {
                slidesPerView: 'auto',
                // freeMode: true,
                allowTouchMove: false,
                loop: true,
                autoplay: {
                    delay: DELAY_VARIATION + Math.round(DELAY_VARIATION*Math.random()),
                }
            });

            block.addEventListener('click', function(ev) {
                if (ev.target.classList.contains('next')) {
                    ev.preventDefault();
                    scrollableModule.slideNext();
                }

                if (ev.target.classList.contains('prev')) {
                    ev.preventDefault();
                    scrollableModule.slidePrev();
                }
            });
        });
    }

    initSwiperBlocks(BLOCK_FREE);
    initSwiperBlocks(BLOCK_PARTICIPATIONS);
    initSwiperBlocks(BLOCK_VIDEOS);

})();
